export const REPIQ_SELECTED_SOCIAL_MEDIA = "REPIQ_SELECTED_SOCIAL_MEDIA";
export const SHOW_LOADER = "SHOW_REPIQ_SELECTEDSOCIAL_SERVICE_LOADER";

export interface ISelectedSocialMediaState {
    selectedSocialMedia: ISelectedSocialMedia;
    isLoading: boolean;
}

export interface ISelectedSocialMedia {
    Status: string;
    Username: string;
    NetworkName: string;
    DisplayOrder: number;
    NetworkID: number;
    LastScanDate: string;
    MinimumWordCountFoundForAIProcess: boolean;
    IsPersonalityAnalysing: boolean;
    Agreeableness: number;
    Conscientiousness: number;
    EmotionalRange: number;
    OpennessToExperiences: number;
    Extraversion: number;
}

export interface getSelectedSocialMedia {
    type: "REPIQ_SELECTED_SOCIAL_MEDIA";
    selectedSocialMedia: ISelectedSocialMedia;
}
export interface ShowAction {
    type: "SHOW_REPIQ_SELECTEDSOCIAL_SERVICE_LOADER";
    isLoading: boolean;
}

export type KnownAction = getSelectedSocialMedia | ShowAction;
